<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-left="70"
    offset-x
    offset-y
    :fixed="true"
    content-class="notifications-menu-box"
  >
    <v-btn icon fab slot="activator" class="xs-toolbar-btn ma-0">
      <v-icon v-if="notifications.length" color="yellow accent-3">notifications_active</v-icon>
      <v-icon v-else>notifications</v-icon>
    </v-btn>
    <!-- <v-badge overlap slot="activator">
      <template v-slot:badge>
        <span>3</span>
      </template>

      <v-avatar
        color="purple red--after"
      >
        <v-icon dark>notifications</v-icon>
      </v-avatar>
    </v-badge> -->
    <v-card class="notification-card">
      <v-list v-if="notifications.length" class="customNotification">
        <v-list-tile >
          <v-list-tile-action>
            <v-icon color="yellow accent-3">email</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>New messages</v-list-tile-title>
          <v-list-tile-action class="mark-read">
            <v-tooltip left>
              <v-icon slot="activator" color="yellow accent-3" @click="markReadAll()">close</v-icon>
              <span>Mark read all messages</span>
            </v-tooltip>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
        <template v-for="(notification, index) in notifications">
          <v-list-tile :key="index" class="py-1">
            <v-list-tile-action>
              <v-icon color="">{{ typeIcons[notification.notification_type] }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ notification.message }}</v-list-tile-title>
            <v-list-tile-action class="mark-read">
              <v-tooltip left>
                <v-icon slot="activator" @click="markRead([notification.id])">close</v-icon>
                <span>Mark read</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="index + 'divider'"></v-divider>
        </template>
      </v-list>
      <v-list v-else class="customNotification">
        <v-list-tile>
          <v-list-tile-action>
            <v-icon color="teal darken-2">done</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>No notifications</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'Notifications',
  data () {
    return {
      notifications: [],
      globalNotificationsIds: [],
      interval: null,
      globalNotificationsCookieName: 'global_notifications_ids_1',
      typeIcons: {
        PASTED_LINKS: 'insert_link',
        NOTIFICATION: 'comment',
        ADMIN_MESSAGE: 'notification_important',
        // PAYMENTS: 'monetization_on',
        PAYMENTS: 'attach_money',
        REPORTS: 'icon-docs'
      }
    }
  },
  created () {
    // this.startLooping()
    this.connectToWebsocket()
  },
  mounted () {
    // this.getNotifications()
    let strGlobalNotificationsIds = this.$cookies.get(this.globalNotificationsCookieName)
    if (strGlobalNotificationsIds) this.globalNotificationsIds = JSON.parse(strGlobalNotificationsIds)
  },
  beforeDestroy () {
    // clearInterval(this.interval)
  },
  methods: {
    getNotifications () {
      if (this.$store.state.user.package_id) {
        this.$store.dispatch('NOTIFICATIONS').then(res => {
          this.notifications = res.notifications
          if (res.global_notifications.length) this.showGlobalNotifications(res.global_notifications)
        }, err => {
          console.log('NOTIFICATIONS ERROR', err)
          // this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
        })
      }
    },
    markRead (ids) {
      this.$store.dispatch('MARK_NOTIFICATIONS', ids).then(res => {
        this.getNotifications()
      }, err => {
        console.log('MARK_NOTIFICATIONS ERROR', err)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    markReadAll () {
      let ids = this.notifications.map((notification) => { return notification.id })
      this.markRead(ids)
    },
    showGlobalNotifications (notifications) {
      let alertMessage = ''
      notifications.forEach(element => {
        if (!this.globalNotificationsIds.includes(element.id)) {
          alertMessage += `<p>${element.message}</p>`
          this.globalNotificationsIds.push(element.id)
          this.$cookies.set(this.globalNotificationsCookieName, JSON.stringify(this.globalNotificationsIds))
        }
      })
      if (alertMessage) this.$eventEmitter.$emit('showAlert', 'warning', 'Attention!', alertMessage)
    },
    startLooping () {
      this.interval = setInterval(() => {
        this.getNotifications()
      }, this.$store.state.settings.notificationsLoop)
    },
    connectToWebsocket () {
      const socket = new WebSocket(this.$store.state.settings.notificationsSocket)
      socket.onopen = () => {
        socket.send(JSON.stringify(
          {name: 'handshake', args: {'key': this.$store.state.auth.token}}
        ))
      }
      socket.onerror = (err) => {
        console.log('WebSocket error ' + err)
        // let errorText = this.$services.getApiError(err)
        // if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "Failed to connect to notifications websocket"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      }
      socket.onmessage = (res) => {
        if (res.data) {
          let data = JSON.parse(res.data)
          this.notifications = data.notifications || []
          if (data.global_notifications && data.global_notifications.length) this.showGlobalNotifications(data.global_notifications)
        }
      }
      socket.onclose = () => {
        // Try to reconnect in 5 seconds
        // setTimeout(this.connectToWebsocket(), 10000)
      }
    }
  }
}
</script>

<style lang="scss">
.notifications-menu-box {
  position: fixed;
  top: 56px !important;
  max-height: 90%;
}
.customNotification .v-list__tile .v-list__tile__action.mark-read {
  min-width: 20px;
  padding-left: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/Notifications.vue